<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M10 29a1 1 0 01-1-1v-5H4a1 1 0 010-2h6a1 1 0 011 1v6a1 1 0 01-1 1zM28 11h-6a1 1 0 01-1-1V4a1 1 0 012 0v5h5a1 1 0 010 2zM11 10a1 1 0 01-1 1H4a1 1 0 010-2h5V4a1 1 0 012 0zM22 29a1 1 0 01-1-1v-6a1 1 0 011-1h6a1 1 0 010 2h-5v5a1 1 0 01-1 1zM19 20h-6a1 1 0 01-1-1v-6a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1zm-5-2h4v-4h-4z"/></svg>